import React from 'react';
import DispositionGapBadge from './DispositionGapBadge';

export default function DispositionToolListRow({ tool, selected, onSelect }) {
  const thumb = (tool.photo_urls && tool.photo_urls[0]) || null;

  return (
    <button
      type="button"
      className={`dispositions-row${selected ? ' selected' : ''}`}
      onClick={() => onSelect(tool.tool_id)}
      aria-pressed={selected}
    >
      <div className="dispositions-row-thumb">
        {thumb
          ? <img src={thumb} alt="" loading="lazy" />
          : <span className="dispositions-row-thumb-empty" />}
      </div>
      <div className="dispositions-row-meta">
        <div className="dispositions-row-id">
          {tool.supplier_tool_id || tool.tool_id || ''}
        </div>
        <div className="dispositions-row-sub">
          {tool.tool_type && (
            <span className="dispositions-row-tool-type">{tool.tool_type}</span>
          )}
          {tool.oem && (
            <span className="dispositions-row-oem">{tool.oem}</span>
          )}
        </div>
      </div>
      <DispositionGapBadge level={tool.gap_level} />
      {tool.submittable_basis === 'DWELL_EXCEEDED' && (
        <span
          className="dispositions-gap-badge"
          style={{ background: 'var(--color-accent-light)', color: 'var(--color-accent-hover)' }}
          title="Submittable because the dwell threshold was exceeded"
        >
          Dwell exceeded
        </span>
      )}
    </button>
  );
}
